var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 7.609C9.8 7.28 9.562 7.014 9.24 6.923C8.351 6.678 7.7 5.866 7.7 4.9V1.4H8.4C8.785 1.4 9.1 1.085 9.1 0.7C9.1 0.315 8.785 0 8.4 0H1.4C1.015 0 0.7 0.315 0.7 0.7C0.7 1.085 1.015 1.4 1.4 1.4H2.1V4.9C2.1 5.866 1.449 6.678 0.56 6.923C0.238 7.014 0 7.28 0 7.609V7.7C0 8.085 0.315 8.4 0.7 8.4H4.186L4.2 13.3C4.2 13.685 4.515 14 4.9 14C5.285 14 5.6 13.685 5.6 13.3L5.586 8.4H9.1C9.485 8.4 9.8 8.085 9.8 7.7V7.609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/PinIcon.9dbead3d8eed121040e45a429870281b.svg";
export { ForwardRef as ReactComponent };